import { render, staticRenderFns } from "./ReviewForm.vue?vue&type=template&id=858eedc4&scoped=true&"
import script from "./ReviewForm.vue?vue&type=script&lang=js&"
export * from "./ReviewForm.vue?vue&type=script&lang=js&"
import style0 from "./ReviewForm.vue?vue&type=style&index=0&id=858eedc4&lang=scss&scoped=true&"
import style1 from "./ReviewForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858eedc4",
  null
  
)

export default component.exports